import { Component, OnInit, OnDestroy } from '@angular/core'
import { CheckoutService } from '../checkout.service'
import { CommonService } from '../../../../../shared/services/common.service'
import { Router, ActivatedRoute } from '@angular/router'
import { saveAs } from 'file-saver'
import {
  AuthService,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'
import { ActiveCartFacade } from '@spartacus/cart/base/root'

@Component({
  standalone: false,
  selector: 'vs-order-confirmation',
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./order-confirmation.component.scss'],
})
export class OrderConfirmationComponent implements OnInit, OnDestroy {
  public retrievedObject
  public retrievedEmail
  public placeOrderData
  public confirmCode
  public confirmEmail
  public pdfDownload
  public getPdf
  isLoggedinUser = false
  cartId: any
  public userType
  public quoteUpdate = false

  constructor(
    private checkoutService: CheckoutService,
    private commonService: CommonService,
    private auth: AuthService,
    private globalMessageService: GlobalMessageService,
    public router: Router,
    public activeCartService: ActiveCartFacade,
    private activatedRoute: ActivatedRoute
  ) {
    this.activeCartService.getActiveCartId().subscribe(
      (success) => {
        this.cartId = success
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  getPDFDownload(cartId) {
    const apiParam = [
      'users',
      'current',
      'vscart',
      cartId,
      'getTermsAndConditions',
    ]
    const apiUrl = this.commonService.constructUrl(apiParam)
    this.commonService.getData(apiUrl).subscribe(
      (success) => {
        this.pdfDownload = success
        this.getPdf = this.pdfDownload.associatedPdf
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['value'] == 'true') {
        this.quoteUpdate = true
      }
    })
    // this.confirmCode = this.checkoutService.storeOrderId; //this.checkoutService.getCartCode();
    this.checkoutService.storeOrderId.subscribe((data) => {
      this.confirmCode = data
      if (this.confirmCode === undefined || this.confirmCode === '')
        this.confirmCode = sessionStorage.getItem('orderCode')
    })
    this.checkoutService.storeOrderEmail.subscribe((data) => {
      this.confirmEmail = data
      if (this.confirmEmail === undefined || this.confirmEmail === '')
        this.confirmEmail = sessionStorage.getItem('orderNotificationEmail')
    })

    this.checkoutService.orderSubmittedStatus.next(true)

    // this.confirmEmail = this.checkoutService.getCartEmail();
    if (this.cartId !== undefined) this.getPDFDownload(this.cartId)
    this.auth.isUserLoggedIn().subscribe(
      (success) => {
        if (success) {
          this.isLoggedinUser = success
          this.userType = 'current'
        } else {
          this.userType = 'anonymous'
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  downloadPdf() {
    this.checkoutService
      .downloadOrderCnfPdf(this.userType, this.confirmCode)
      .subscribe(
        (res) => {
          if (res !== null && res !== undefined) {
            const fileName = 'OrderSubmission_' + this.confirmCode
            const blob = new Blob([res], { type: 'application/pdf' })
            const file = new File([blob], fileName + '.pdf', {
              type: 'application/pdf',
            })
            saveAs(file)
          } else {
            this.globalMessageService.add(
              { key: 'orderCheckOut.pdfNotAvailable' },
              GlobalMessageType.MSG_TYPE_ERROR,
              10000
            )
          }
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  ngOnDestroy() {
    const obj = { code: '', name: '', selected: 'false' }
    this.checkoutService.specialdocSIData.next(obj)
    this.checkoutService.finaltestSIData.next(obj)
    this.checkoutService.valvesdimenSIData.next(obj)
    this.checkoutService.othersSIData.next(obj)
    this.checkoutService.inspectionTestSIData.next(obj)
    this.checkoutService.cMTRSSIData.next(obj)
    this.checkoutService.iNstructionSIData.next(obj)
    // this.checkoutService.bankGuaranteeData.next(obj);
    this.checkoutService.witnessInspctnData.next(obj)
    this.checkoutService.inOrderFlowOnly.next(false)
    this.checkoutService.storeOrderId.next('')
    this.checkoutService.storeOrderEmail.next('')
    this.checkoutService.getCartServerResponse.next({})
    this.checkoutService.getCartIdResponse.next('')
    this.checkoutService.getCartReviewOrderResponse.next({})
    this.checkoutService.shipingInstrctnData.next('')
    this.checkoutService.sendShipDetails('')
    this.checkoutService.getSepcsialInst.next({})
  }
}
